export default "__VITE_ASSET__cfafc73b__"